/* ==========================================================================
   VOCAL CHEF — page-level behaviour (FAQ filter, contact topic, account UI).
   Every feature here is an enhancement: the content is server-rendered first,
   so nothing is hidden behind JS.
   ========================================================================== */
(function () {
  'use strict';
  var doc = document;
  var $  = function (s, r) { return (r || doc).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || doc).querySelectorAll(s)); };

  /* ---------------- FAQ live filter ---------------- */
  function initFaqFilter() {
    var box = $('[data-vc-faq-search]');
    var host = $('[data-vc-faq-centre]');
    if (!box || !host || host.dataset.vcInit) return;
    host.dataset.vcInit = '1';

    var clear = $('[data-vc-faq-clear]');
    var count = $('[data-vc-faq-count]');
    var empty = $('[data-vc-faq-empty]');
    var nav   = $('[data-vc-faq-nav]');
    var items = $$('[data-vc-faq-item]', host);
    var total = Number(host.getAttribute('data-total') || items.length);
    var ofWord = host.getAttribute('data-of') || 'of';
    var qWord  = host.getAttribute('data-questions') || 'questions';

    var norm = function (s) { return String(s).toLowerCase().replace(/[^a-z0-9 ]/g, ' '); };

    function run(term) {
      var t = norm(term || '').trim();
      var shown = 0;
      items.forEach(function (item) {
        var hit = !t || norm(item.textContent).indexOf(t) > -1;
        item.hidden = !hit;
        item.classList.toggle('on', !!t && hit);
        if (hit) shown++;
      });
      $$('.qgroup', host).forEach(function (g) {
        var any = $$('[data-vc-faq-item]', g).some(function (i) { return !i.hidden; });
        g.hidden = !any;
        var link = nav && nav.querySelector('[data-navfor="' + g.getAttribute('data-group') + '"]');
        if (link) link.hidden = !any;
      });
      if (empty) empty.hidden = shown > 0;
      if (count) count.textContent = t ? shown + ' ' + ofWord + ' ' + total + ' ' + qWord : total + ' ' + qWord;
      if (clear) clear.hidden = !term;
    }

    box.addEventListener('input', function () { run(box.value); });
    if (clear) clear.addEventListener('click', function () { box.value = ''; run(''); box.focus(); });
    run('');
  }

  /* ---------------- contact: ?topic= preselects the subject ---------------- */
  function initTopic() {
    var sel = $('[data-vc-topic]');
    if (!sel) return;
    var want = new URLSearchParams(window.location.search).get('topic');
    if (!want) return;
    var norm = function (s) { return String(s).toLowerCase().replace(/[^a-z0-9]/g, ''); };
    var target = norm(want);
    Array.prototype.slice.call(sel.options).forEach(function (o) {
      if (norm(o.value).indexOf(target) > -1 || norm(o.textContent).indexOf(target) > -1) sel.value = o.value;
    });
  }

  /* ---------------- account: login / recover panels ---------------- */
  function initAccount() {
    var toggles = $$('[data-vc-acct-toggle]');
    if (!toggles.length) return;
    function show(which) {
      var login = $('#login'), recover = $('#recover');
      if (!login || !recover) return;
      login.hidden = which === 'recover';
      recover.hidden = which !== 'recover';
      var focusEl = (which === 'recover' ? recover : login).querySelector('input');
      if (focusEl) focusEl.focus();
    }
    toggles.forEach(function (b) {
      b.addEventListener('click', function (e) { e.preventDefault(); show(b.getAttribute('data-vc-acct-toggle')); });
    });
    if (window.location.hash === '#recover') show('recover');
  }

  /* ---------------- addresses: inline edit ---------------- */
  function initAddresses() {
    $$('[data-vc-addr-edit]').forEach(function (b) {
      b.addEventListener('click', function () {
        var box = doc.getElementById('addr-' + b.getAttribute('data-vc-addr-edit'));
        if (box) box.hidden = !box.hidden;
      });
    });
    $$('select[data-default]').forEach(function (sel) {
      var v = sel.getAttribute('data-default');
      if (v) sel.value = v;
    });
  }

  function boot() { initFaqFilter(); initTopic(); initAccount(); initAddresses(); }
  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', boot); else boot();
  doc.addEventListener('shopify:section:load', boot);
})();
